import { z } from "zod";
import {
  PORTAL_NUMERIC_REMINDER_MAX_DAYS,
  PORTAL_NUMERIC_REMINDER_MIN_DAYS,
} from "./client-portal-features";

/** Nombre maximal de groupes de métriques par cabinet. */
export const METRIC_GROUPS_MAX = 15;

/** Nombre maximal de métriques référençables par groupe (limite la même que celle du cabinet). */
export const METRIC_GROUP_METRIC_IDS_MAX = 50;

/**
 * Création / mise à jour d'un groupe de métriques par le pro.
 * `metricIds` doit pointer vers des `id` existants dans `clientPortalFeatures.numericDefinitions`.
 */
export const MetricGroupSchema = z.object({
  name: z
    .string({ required_error: "Nom requis" })
    .trim()
    .min(1, "Nom requis")
    .max(60, "60 caractères max"),
  metricIds: z
    .array(z.string().min(1).max(64))
    .max(METRIC_GROUP_METRIC_IDS_MAX)
    .default([]),
  /** Rappel automatique pour les clients assignés à ce groupe. */
  reminderEnabled: z.boolean().optional(),
  reminderIntervalDays: z
    .number()
    .int()
    .min(PORTAL_NUMERIC_REMINDER_MIN_DAYS)
    .max(PORTAL_NUMERIC_REMINDER_MAX_DAYS)
    .optional(),
  position: z.number().int().min(0).optional(),
});

export type MetricGroupDto = z.infer<typeof MetricGroupSchema>;

/**
 * Liste d'IDs de groupes assignés à un client (utilisé pour PUT /clients/:id/metric-groups).
 * Les doublons sont normalisés et l'ordre n'a pas d'importance.
 */
export const MetricGroupAssignmentSchema = z.object({
  groupIds: z.array(z.string().min(1)).default([]),
});

export type MetricGroupAssignmentDto = z.infer<
  typeof MetricGroupAssignmentSchema
>;

/**
 * Liste d'IDs de clients d'un groupe (utilisé pour PUT /metric-groups/:id/clients).
 */
export const MetricGroupClientsSchema = z.object({
  clientIds: z.array(z.string().min(1)).default([]),
});

export type MetricGroupClientsDto = z.infer<typeof MetricGroupClientsSchema>;
